import React from "react";

/**
 * ProfileProgressRing — anillo circular animado de progreso 0–100.
 * Reutilizable en TODO el ecosistema (Mi Perfil, Home dashboard, Perfil Público).
 * Etapa 3 §6.10, componente `<BarraProgresoPerfil>`.
 */

export function ProfileProgressRing({
  value = 0,
  size = 96,
  strokeWidth = 8,
  showLabel = true,
  label,
  testid = "profile-progress-ring",
}) {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (v / 100) * circumference;

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid={testid}
      role="progressbar"
      aria-valuenow={v}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label || `Perfil completado al ${v} por ciento`}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#E6EEF9"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#0F4C9E"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 400ms cubic-bezier(0.4,0,0.2,1)" }}
        />
      </svg>
      {showLabel && (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-xl font-bold text-slate-900 tabular-nums" data-testid={`${testid}-value`}>
            {v}%
          </span>
        </div>
      )}
    </div>
  );
}

export default ProfileProgressRing;
